import Preloader from "components/Preloader/Preloader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { addAccessory, fetchAccessoryOptions, selectAccessoryOptions } from "../accessoriesAdminSlice";
import AccessoryForm from "./AccessoryForm";

const AddAccessory = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const fields = useSelector(selectAccessoryOptions);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(fetchAccessoryOptions());
  }, [dispatch]);

  const onSubmit = (data: any) => {
    if (data.image.file_name || data.image.file) {
      dispatch(
        addAccessory(data, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        })
      );
      navigate(-1);
    } else {
      alert("Добави снимка");
    }
  };

  return fields ? (
    <AccessoryForm formTitle="Добавяне на аксесоар" onSubmit={onSubmit} fields={fields} progress={progress} />
  ) : (
    <Preloader />
  );
};
const LoaderContainer = styled.div`
  width: 100vw;
  height: 100vh;
`;
export default AddAccessory;
